// extracted by mini-css-extract-plugin
export default {"angleOfRotationGroup":"styles_angleOfRotationGroup__QNr0O","select":"styles_select__1CEKV"};